import {IBaseLookup} from "./Ibase.lookup";

export namespace ScheduleScheme {

    export const lookupName: string = "ScheduleScheme";

    export interface ScheduleScheme {
        scheduleSchemeKey: number;
        description: string;
        code: string;
        defaultFlag: string;
        active: string;
        lastUpdated: Date;
    }

    export interface ScheduleSchemeDS extends IBaseLookup {
        scheduleScheme: ScheduleScheme[];
    }
}
